// extracted by mini-css-extract-plugin
export default {"navigationContainer":"styles_navigationContainer__lihIm","navigationItem":"styles_navigationItem__qY8d4","span":"styles_span__R0BEW"};